var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, CustomElement, Watch, styleMap, html } from '@sick-davinci/ce-decorators';
import { CssTools } from '../_utils/CssTools.js';
export
/**
 * Base class for text charts
 */
let TextChartBase = (_dec = Component({
  abstract: true
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Watch('size'), _dec9 = Reflect.metadata("design:paramtypes", [String, String]), _dec(_class = (_class2 = (_temp = _class3 = class TextChartBase extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "size", _descriptor, this);

    _initializerDefineProperty(this, "textColor", _descriptor2, this);

    _initializerDefineProperty(this, "subText", _descriptor3, this);

    this._fontSize = new Map([['xsmall', {
      value: '2rem',
      unit: '.75rem',
      subtext: '0.7rem'
    }], ['small', {
      value: '3rem',
      unit: '1rem',
      subtext: '0.7rem'
    }], ['normal', {
      value: '4.5rem',
      unit: '1.5rem',
      subtext: '0.75rem'
    }], ['large', {
      value: '6.75rem',
      unit: '2.25rem',
      subtext: '1.2rem'
    }], ['xlarge', {
      value: '10rem',
      unit: '3.5rem',
      subtext: '2rem'
    }]]);
    this._ro = new ResizeObserver(() => this.scheduleRender(true));
  }

  /**
   * size sanitizer
   *
   * @param _ - old value
   * @param nv - new valuee
   */
  sizeChanged(_, nv) {
    if (!TextChartBase.SIZE_ORDER.some(fs => fs === nv)) {
      this.size = 'xlarge';
    }
  }
  /**
   * See base class
   */


  componentConnected() {
    this._ro.observe(this);
  }
  /**
   * See base class
   */


  componentDisconnected() {
    this._ro.disconnect();
  }
  /**
   * Calculate text width based on the given string and font-size
   *
   * @param text - the actual text to determine the size for
   * @param fontSize - the font size for the given text
   * @returns the size
   */


  _textWidth(text, fontSize) {
    const tag = document.createElement('div');
    tag.style.position = 'absolute';
    tag.style.whiteSpace = 'nowrap';
    tag.style.visibility = 'hidden';
    tag.style.fontFamily = getComputedStyle(this).fontFamily;
    tag.style.fontSize = fontSize;
    tag.innerHTML = text + '.'; // add a blank to make sure the width is definately as big as it is rendered (might vary)

    this.shadowRoot.appendChild(tag);
    const result = tag.clientWidth;
    this.shadowRoot.removeChild(tag);
    return result;
  }

  _totalTextHeight(size) {
    return CssTools.REM2PIXEL(Number.parseFloat(this._fontSize.get(size).value)) + (this.subText ? CssTools.REM2PIXEL(Number.parseFloat(this._fontSize.get(size).subtext)) + CssTools.REM2PIXEL(2) : 0); // margins
  }

  _renderSubtext(size) {
    return this.subText ? html`<div id='subtext' style=${styleMap({
      fontSize: this._fontSize.get(size).subtext,
      lineHeight: this._fontSize.get(size).subtext
    })}>${this.subText}</div>` : html``;
  }

}, _class3.SIZE_ORDER = new Array('xsmall', 'small', 'normal', 'large', 'xlarge'), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "size", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'xlarge';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "textColor", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "subText", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "sizeChanged", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "sizeChanged"), _class2.prototype)), _class2)) || _class);
